// The report's days are cut in a named zone: Paris by default, whatever the viewer's own clock.
export const DEFAULT_ZONE = 'Europe/Paris'

const browserZone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone } catch (e) { return null }
}

// Paris first, then UTC, then the viewer's own zone when it is neither
export const zoneOptions = () => [...new Set([DEFAULT_ZONE, 'UTC', browserZone()].filter(Boolean))]

// wall-clock fields of an instant in the zone
const wallClock = (zone, at) => {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(at)
  const get = (type) => Number(parts.find((part) => part.type === type).value)
  return { year: get('year'), month: get('month'), day: get('day'), hour: get('hour'), minute: get('minute'), second: get('second') }
}

const offsetMs = (zone, at) => {
  const w = wallClock(zone, at)
  return Date.UTC(w.year, w.month - 1, w.day, w.hour, w.minute, w.second) - Math.floor(at.getTime() / 1000) * 1000
}

// the instant a wall-clock time happens in the zone; the second pass settles a DST change between guess and answer
const zonedInstant = (date, h, mi, s, ms, zone) => {
  const guess = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), h, mi, s, ms)
  const first = guess - offsetMs(zone, new Date(guess))
  return new Date(guess - offsetMs(zone, new Date(first)))
}

// the picker hands back local Dates: their calendar day is the one picked, re-anchored in the report's zone
export const dayStart = (date, zone) => zonedInstant(date, 0, 0, 0, 0, zone)
export const dayEnd = (date, zone) => zonedInstant(date, 23, 59, 59, 999, zone)

// today in the zone, as a local Date the picker shows as that calendar day
export const todayIn = (zone) => {
  const w = wallClock(zone, new Date())
  return new Date(w.year, w.month - 1, w.day)
}
